import React, { useState } from 'react';
import {Grid,TableContainer,Table,TableHead,TableBody,TableRow,TableCell,Paper, Button,TextField, Box} from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';


 

  function Parameters() {
 // First table
 const [data, setData] = useState([
    { id: 1, item: 'Enquiry' },
    { id: 2, item: 'Estimate' },
    { id: 3, item: 'Rejected' },
  ]);
  const [newItem, setNewItem] = useState('');
  const [editData, setEditData] = useState(null);

  // Second table
  const [data2, setData2] = useState([
    { id: 1, item: 'MOT' },
    { id: 2, item: 'Running Repair' },
    { id: 3, item: 'General Repair' },
  ]);
  const [newItem2, setNewItem2] = useState('');
  const [editData2, setEditData2] = useState(null);

  // Third table
  const [data3, setData3] = useState([
    { id: 1, item: 'Under Work' },
    { id: 2, item: 'Work Approval' },
    { id: 3, item: 'Work Completed' },
 ]);
  const [newItem3, setNewItem3] = useState('');
  const [editData3, setEditData3] = useState(null);

   // Fourth table
  const [data4, setData4] = useState([
    { id: 1, item: 'Supervisor 1' },
    { id: 2, item: 'Supervisor 2' },
    { id: 3, item: 'Supervisor 3' },
  ]);
  const [newItem4, setNewItem4] = useState('');
  const [editData4, setEditData4] = useState(null);


  const handleAdd = (tableNumber) => {
    if (tableNumber === 1 && newItem === '') return;
    if (tableNumber === 2 && newItem2 === '') return;
    if (tableNumber === 3 && newItem3 === '') return;
    if (tableNumber === 4 && newItem4 === '') return;
 
    switch (tableNumber) {
      case 1:
        setData([...data, { id: data.length + 1, item: newItem }]);
        setNewItem('');
        break;
      case 2:
        setData2([...data2, { id: data2.length + 1, item: newItem2 }]);
        setNewItem2('');
        break;
      case 3:
        setData3([...data3, { id: data3.length + 1, item: newItem3 }]);
        setNewItem3('');
        break;
      case 4:
        setData4([...data4, { id: data4.length + 1, item: newItem4 }]);
        setNewItem4('');
        break;
      default:
        break;
    }
  };
  const handleDelete = (id, tableNumber) => {
    switch (tableNumber) {
      case 1:
        const updatedData = data.filter((item) => item.id !== id);
        setData(updatedData);
        break;
      case 2:
        const updatedData2 = data2.filter((item) => item.id !== id);
        setData2(updatedData2);
        break;
      case 3:
        const updatedData3 = data3.filter((item) => item.id !== id);
        setData3(updatedData3);
        break;
      case 4:
        const updatedData4 = data4.filter((item) => item.id !== id);
        setData4(updatedData4);
        break;
      default:
        break;
    }
  };
  const handleEdit = (row, tableNumber) => {
    switch (tableNumber) {
      case 1:
        setEditData({ ...row });
        break;
      case 2:
        setEditData2({ ...row });
        break;
      case 3:
        setEditData3({ ...row });
        break;
      case 4:
        setEditData4({ ...row });
        break;
      default:
        break;
    }
  };
  const handleSave = (tableNumber) => {
    switch (tableNumber) {
      case 1:
        const updatedData = data.map((item) => {
          if (item.id === editData.id) {
            return editData;
          }
          return item;
        });
        setData(updatedData);
        setEditData(null);
        break;
      case 2:
        const updatedData2 = data2.map((item) => {
          if (item.id === editData2.id) {
            return editData2;
          }
          return item;
        });
        setData2(updatedData2);
        setEditData2(null);
        break;
      case 3:
        const updatedData3 = data3.map((item) => {
          if (item.id === editData3.id) {
            return editData3;
          }
          return item;
        });
        setData3(updatedData3);
        setEditData3(null);
        break;
      case 4:
        const updatedData4 = data4.map((item) => {
          if (item.id === editData4.id) {
            return editData4;
          }
          return item;
        });
        setData4(updatedData4);
        setEditData4(null);
        break;
      default:
        break;
    }
  };

  return (
  <Box mt={2}>
    <Grid container spacing={1}>
      <Grid item xs={3} >
        {/* table 1   */}
        <Box >
          <h3 style={{textAlign:'center'}}>Enquiry</h3> 
          <TableContainer component={Paper} >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2} >
                    <TextField label="New Section" value={newItem} onChange={(e) => setNewItem(e.target.value)} style={{width:'250px'}}/>
                    <Button onClick={() => handleAdd(1)}><AddCircleOutlinedIcon style={{ color:'#2e7d32' }}/></Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell  colSpan={1} style={{width:140}}>
                    {editData && editData.id === row.id ? (
                    <TextField value={editData.item} onChange={(e) => setEditData({ ...editData, item: e.target.value })} />
                    ) : (
                      row.item
                    )}
                  </TableCell>
                  <TableCell sx={{padding: '1px'}} >
                    {editData && editData.id === row.id ? (
                    <Button onClick={() => handleSave(1)} sx={{padding:'1px'}} ><BookmarkIcon style={{ color:'#489C8F' }}sx={{ fontSize: "15px" }} /></Button>
                    ) : (<Button disabled sx={{padding:'1px'}}><BookmarkIcon sx={{ fontSize: "15px" }}  /> </Button>)}
                    <Button sx={{padding:'1px'}} onClick={() => handleEdit(row, 1)}><EditIcon style={{ color:'#0066b2' }} sx={{ fontSize: "15px" }}/></Button>
                    <Button sx={{padding:'1px'}} onClick={() => handleDelete(row.id, 1)}><DeleteIcon style={{ color:'#CD5C5C' }} sx={{ fontSize: "15px" }}/></Button>
                  </TableCell>
                </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>

      <Grid item xs={3} >
        {/* table 2   */}
        <Box >
          <h3 style={{textAlign:'center'}}>Service Type</h3>
          <TableContainer component={Paper} >
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell colSpan={2} >
                    <TextField label="New Section" value={newItem2} onChange={(e) => setNewItem2(e.target.value)} style={{width:'250px'}} />
                    <Button onClick={() => handleAdd(2)}><AddCircleOutlinedIcon style={{ color:'#2e7d32' }}/></Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data2.map((row) => (
                <TableRow key={row.id}>
                  <TableCell colSpan={1}  style={{width:140}}>
                    {editData2 && editData2.id === row.id ? (
                    <TextField display='flex' value={editData2.item} onChange={(e) => setEditData2({ ...editData2, item: e.target.value })}/>
                    ) : ( row.item )}
                  </TableCell>
                  <TableCell sx={{padding: '1px'}} >
                    {editData2 && editData2.id === row.id ? (
                    <Button onClick={() => handleSave(2)} sx={{padding:'1px'}}><BookmarkIcon style={{ color:'#489C8F', fontSize:'10px' }} sx={{ fontSize: "15px" }}/> </Button>
                    ) : ( <Button disabled sx={{padding:'1px'}}><BookmarkIcon sx={{ fontSize: "15px" }} /> </Button>)}
                    <Button sx={{padding:'1px'}} onClick={() => handleEdit(row, 2)}><EditIcon style={{ color:'#0066b2' }} sx={{ fontSize: "15px" }}/></Button>
                    <Button sx={{padding:'1px'}} onClick={() => handleDelete(row.id, 2)}><DeleteIcon style={{ color:'#CD5C5C' }} sx={{ fontSize: "15px" }}/></Button>
                  </TableCell>
                </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
      
      <Grid item xs={3} >
        {/* table 3   */}
        <Box >
          <h3 style={{textAlign:'center'}}>Service Status</h3>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell colSpan={2} >
                    <TextField label="New Section" value={newItem3} onChange={(e) => setNewItem3(e.target.value)} style={{width:'250px'}}/>
                    <Button onClick={() => handleAdd(3)}><AddCircleOutlinedIcon style={{ color:'#2e7d32' }}/></Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data3.map((row) => (
                <TableRow key={row.id}>
                  <TableCell colSpan={1}  style={{width:140}}>
                    {editData3 && editData3.id === row.id ? (
                    <TextField  value={editData3.item} onChange={(e) => setEditData3({ ...editData3, item: e.target.value })}/>
                    ) : ( row.item )}
                  </TableCell>
                  <TableCell  sx={{padding: '1px'}} >
                    {editData3 && editData3.id === row.id ? (
                    <Button onClick={() => handleSave(3)} sx={{padding:'1px'}}><BookmarkIcon style={{ color:'#489C8F', fontSize:'10px' }} sx={{ fontSize: "15px" }}/> </Button>
                    ) : ( <Button disabled sx={{padding:'1px'}}><BookmarkIcon  sx={{ fontSize: "15px" }}/> </Button> )} 
                    <Button  sx={{padding:'1px'}} onClick={() => handleEdit(row, 3)}><EditIcon style={{ color:'#0066b2' }} sx={{ fontSize: "15px" }}/></Button>
                    <Button  sx={{padding:'1px'}} onClick={() => handleDelete(row.id, 3)}><DeleteIcon style={{ color:'#CD5C5C' }} sx={{ fontSize: "15px" }}/></Button>
                  </TableCell>
                </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>

      <Grid item xs={3} >
        {/* table 4   */}
        <Box>
          <h3 style={{textAlign:'center'}} >Supervisor Alloted</h3>
          <TableContainer component={Paper} >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}>
                    <TextField label="New Section" value={newItem4} onChange={(e) => setNewItem4(e.target.value)} style={{width:'250px'}}/>
                    <Button  onClick={() => handleAdd(4)}><AddCircleOutlinedIcon style={{ color:'#2e7d32' }}/></Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data4.map((row) => (
                <TableRow key={row.id}>
                  <TableCell colSpan={1}  style={{width:140}} >
                    {editData4 && editData4.id === row.id ? (
                      <TextField  value={editData4.item} onChange={(e) => setEditData4({ ...editData4, item: e.target.value })}/>
                      ) : ( row.item )}
                    </TableCell>
                  <TableCell sx={{padding: '1px'}}>
                    {editData4 && editData4.id === row.id ? (
                    <Button onClick={() => handleSave(4)} sx={{padding:'1px'}}><BookmarkIcon style={{ color:'#489C8F', fontSize:'10px'}} sx={{ fontSize: "15px" }}/> </Button>
                    ) : ( <Button disabled sx={{padding:'1px'}}><BookmarkIcon sx={{ fontSize: "15px" }} /> </Button> )}
                    <Button sx={{padding:'1px'}} onClick={() => handleEdit(row, 4)}><EditIcon style={{ color:'#0066b2' }} sx={{ fontSize: "15px" }}/></Button>
                    <Button sx={{padding:'1px'}} onClick={() => handleDelete(row.id, 4)}><DeleteIcon style={{ color:'#CD5C5C' }} sx={{ fontSize: "15px" }}/></Button>
                  </TableCell>
                </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box> 
      </Grid>

    </Grid>
  </Box>
  );
}
export default Parameters